import React from "react";
import { usePromiseTracker } from "react-promise-tracker";
import "bootstrap/dist/css/bootstrap.min.css";

const Spinner: React.FC = () => {
    const { promiseInProgress } = usePromiseTracker(null);

    return (
        promiseInProgress
        && (
            <div className="d-flex justify-content-center cover-spinner">
                <div className="spinner-border position-fixed top-50" data-testid="spinner" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    );
}

export default Spinner;
